import Icon from '../components/Icon.vue'

Icon.register({"graduation-cap":{"width":640,"height":512,"paths":[{"d":"M622.9 199L347.1 284.1A96-96 0 0 0 292.9 284.1L92.4 222.2C83.8 233.7 81.4 245.3 80.5 260.6 89.8 266.2 96 276.4 96 288 96 300 89.4 310.4 79.7 315.9L95.9 439C96.6 443.7 92.8 448 88 448H40C35.2 448 31.4 443.7 32.1 439L48.3 315.9C38.6 310.4 32 300 32 288 32 276 38.6 265.5 48.5 260 49.4 242.1 52.4 226.8 60.6 212.4L17.1 199C-5.8 192.2-5.7 159.8 17.1 153L292.9 67.9A96-96 0 0 0 347.1 67.9L622.9 153C645.8 159.8 645.7 192.2 622.9 199zM356.5 314.7L356.3 314.7 356.1 314.8A128-128 0 0 0 283.9 314.8L283.7 314.7 283.5 314.7 132.6 268.1 120 352C120 387.3 209.5 416 320 416S520 387.3 520 352L507.4 268.1 356.5 314.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/graduation-cap.js
// module id = null
// module chunks = 